import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CookieService } from './cookie.service';
import { Documentacion } from '../models/documentacion.model';
import { Plantilla } from '../models/plantilla.model';
import { Mail } from '../models/envioMail.model';
import { environment } from '../../../environments/environment';

// const baseUrl = 'https://gestionmontepio.gruposca.net/APIGESTION-1/';

const baseUrl = environment.baseURL;

// const baseUrl = "http://localhost:8080/"


@Injectable({
  providedIn: 'root'
})
export class ApiService {


  constructor(private http: HttpClient,
    public cookieService: CookieService,

  ) { }

  getData(): Observable<any> {
    const url = baseUrl + 'posts';
    return this.http.get<any>(url);
  }

  login(dni: string, password: string): Observable<any> {
    const url = baseUrl + 'public/login';
    const body = { username: dni, password: password };


    return this.http.post<any>(url, body);
  }

  getHome(): Observable<any> {
    const url = baseUrl + 'gestion/homegestion';


    // Realizar la petición HTTP GET con los headers incluidos
    return this.http.get<any>(url);
  }

  getAsociados(): Observable<any> {
    const user = JSON.parse(localStorage.getItem('currentUser') || '{}')
    const url = baseUrl + 'gestion/asociados/min';


    // Realizar la petición HTTP GET con los headers incluidos
    return this.http.get<any>(url);
  }

  getAsociadosMinSearch(): Observable<any> {
    const user = JSON.parse(localStorage.getItem('currentUser') || '{}')
    const url = baseUrl + 'gestion/asociados/minSearch';


    // Realizar la petición HTTP GET con los headers incluidos
    return this.http.get<any>(url);
  }

  getAsociadosCompleto(): Observable<any> {
    const user = JSON.parse(localStorage.getItem('currentUser') || '{}')
    const url = baseUrl + 'gestion/asociados';


    // Realizar la petición HTTP GET con los headers incluidos
    return this.http.get<any>(url);
  }


  getUsuarios(): Observable<any> {
    const user = JSON.parse(localStorage.getItem('currentUser') || '{}')
    const url = baseUrl + 'gestion/usuarios';


    // Realizar la petición HTTP GET con los headers incluidos
    return this.http.get<any>(url);
  }

  getAsociadosMail(): Observable<any> {
    const url = baseUrl + 'gestion/asociados/emails'

    return this.http.get<any>(url);
  }
  getAsociadosTipo(): Observable<any> {
    const url = baseUrl + 'gestion/tipoasociados'

    return this.http.get<any>(url);
  }
  getMunicipios(): Observable<any> {
    const url = baseUrl + 'gestion/municipios'

    return this.http.get<any>(url);
  }
  getAsociadosSituacion(): Observable<any> {
    const url = baseUrl + 'gestion/situaciones'

    return this.http.get<any>(url);
  }

  getAccesos(): Observable<any> {
    const user = JSON.parse(localStorage.getItem('currentUser') || '{}')
    const url = baseUrl + 'gestion/accesosasociados';


    // Realizar la petición HTTP GET con los headers incluidos
    return this.http.get<any>(url);
  }

  getAccesosSearch(page: number, asociado: number, excluirIp: string, incluirIp: string, filtroAgente: string, fechaDesde: string, fechaHasta: string, asoUnico: boolean, order: string, direction: string, items: number): Observable<any> {
    const url = baseUrl + 'gestion/accesosasociados/search';
    const body = { page: page, filters: { asociado: asociado, excluirIp, incluirIp, filtroAgente, fechaDesde: fechaDesde, fechaHasta: fechaHasta, asoUnico: asoUnico }, order: order, direction: direction, items: items, agrupacion: 'all' };

    // Realizar la petición HTTP GET con los headers incluidos
    return this.http.post<any>(url, body);
  }

  getAccesosExcel(page: number, asociado: number, excluirIp: string, incluirIp: string, filtroAgente: string, fechaDesde: string, fechaHasta: string, asoUnico: boolean, order: string, direction: string, items: number, agrupacion: string): Observable<any> {
    const url = baseUrl + 'gestion/accesosasociados/excel';
    const body = { page: page, filters: { asociado: asociado, excluirIp, incluirIp, filtroAgente, fechaDesde: fechaDesde, fechaHasta: fechaHasta, asoUnico: asoUnico }, order: order, direction: direction, items: items, agrupacion: agrupacion };

    // Realizar la petición HTTP GET con los headers incluidos
    return this.http.post<any>(url, body);
  }
  getDocumentacion(): Observable<any> {
    const user = JSON.parse(localStorage.getItem('currentUser') || '{}')
    const url = baseUrl + 'gestion/documentos/min';


    // Realizar la petición HTTP GET con los headers incluidos
    return this.http.get<any>(url);
  }

  getPlantillas(): Observable<any> {
    const url = baseUrl + 'gestion/plantillas/min';
    // Realizar la petición HTTP GET con los headers incluidos
    return this.http.get<any>(url);
  }

  getReclamaciones(): Observable<any> {
    const user = JSON.parse(localStorage.getItem('currentUser') || '{}')
    const url = baseUrl + 'gestion/reclamaciones/min';


    // Realizar la petición HTTP GET con los headers incluidos
    return this.http.get<any>(url);
  }

  getDetallesAsociado(id: string): Observable<any> {
    const url = baseUrl + 'gestion/asociado/' + id;

    return this.http.post<any>(url, null);
  }


  getDetallesReclamacion(id: string): Observable<any> {
    const url = baseUrl + 'gestion/reclamaciones/' + id;

    return this.http.post<any>(url, null);
  }

  getDetallesUser(): Observable<any> {
    const user = JSON.parse(localStorage.getItem('currentUser') || '{}')

    const url = baseUrl + 'gestion/usuario/' + user.id;

    return this.http.post<any>(url, null);
  }

  getDetallesDocument(id: number): Observable<any> {

    const url = baseUrl + 'gestion/documentos/' + id;

    return this.http.post<any>(url, null);
  }

  getDetallesPlantilla(id: string): Observable<any> {

    const url = baseUrl + 'gestion/plantillas/' + id;

    return this.http.post<any>(url, null);
  }

  changePassword(oldPassword: string, newPassword: string): Observable<any> {
    const url = baseUrl + 'gestion/changepass';
    const user = JSON.parse(localStorage.getItem('currentUser') || '{}')
    const body = { id: user.id, oldPassword: oldPassword, newPassword: newPassword };

    return this.http.post<any>(url, body);
  }

  newDocument(document: Documentacion): Observable<any> {
    const url = baseUrl + 'gestion/documentos/alta';
    const user = JSON.parse(localStorage.getItem('currentUser') || '{}')
    const body = { id: 0, fecha: document.fecha, referencia: document.referencia, file_name: document.file_name, file_data: document.file_data, asociado: document.asociadoId, visible: document.visible };

    return this.http.post<any>(url, body);
  }

  saveDocument(document: Documentacion): Observable<any> {
    const url = baseUrl + 'gestion/documentos/save';
    const user = JSON.parse(localStorage.getItem('currentUser') || '{}')
    const body = { id: document.id, fecha: document.fecha, referencia: document.referencia, file_name: document.file_name, file_data: document.file_data, asociado: document.asociadoId, visible: document.visible };

    return this.http.post<any>(url, body);
  }

  deleteDocument(id: number): Observable<any> {
    const url = baseUrl + 'gestion/documentos/delete/' + id;

    return this.http.post<any>(url, null);
  }

  newPlantilla(plantilla: Plantilla): Observable<any> {
    const url = baseUrl + 'gestion/plantillas/alta';
    const body = { id: 0, nombre: plantilla.nombre, html: plantilla.html, activo: plantilla.activo };

    return this.http.post<any>(url, body);
  }

  savePlantilla(plantilla: Plantilla): Observable<any> {
    const url = baseUrl + 'gestion/plantillas/save';
    const body = { id: plantilla.id, nombre: plantilla.nombre, html: plantilla.html, activo: plantilla.activo };

    return this.http.post<any>(url, body);
  }

  deletePlantilla(id: number): Observable<any> {
    const url = baseUrl + 'gestion/plantillas/delete/' + id;

    return this.http.post<any>(url, null);
  }

  mailPendientes(): Observable<any> {
    const url = baseUrl + 'gestion/emails/pendientes';
    return this.http.post<any>(url, null);
  }
  envioMail(mails: Mail[]): Observable<any> {
    const url = baseUrl + 'gestion/emails/alta';
    const body = mails;

    return this.http.post<any>(url, body);
  }

  getAportaciones(id: string): Observable<any> {
    const url = baseUrl + 'gestion/aportaciones/' + id;

    return this.http.post<any>(url, null);
  }

  getPrestaciones(id: string): Observable<any> {
    const url = baseUrl + 'gestion/prestaciones/' + id;

    return this.http.post<any>(url, null);
  }

  getDerechos(id: string): Observable<any> {
    const url = baseUrl + 'gestion/derechos/' + id;

    return this.http.post<any>(url, null);
  }


  getListadoAportacionesSearch(page: number, nombre: string, apellidos: string, numero: string, dni: string, fnacDesde: string, fnacHasta: string, apoDesde: string, apoHasta: string, situacionAso: number, tipoAso: number, tipoApo: number, order: string, direction: string, items: number): Observable<any> {
    const url = baseUrl + 'gestion/aportaciones/all';
    const body = { page: page, filters: { nombre: nombre, apellidos: apellidos, numero: numero, dni: dni, fnacDesde: fnacDesde, fnacHasta: fnacHasta, apoDesde: apoDesde, apoHasta: apoHasta, situacion: situacionAso, tipo: tipoAso, tipoAportacion: tipoApo }, order: order, direction: direction, items: items };

    // Realizar la petición HTTP GET con los headers incluidos
    return this.http.post<any>(url, body);
  }

  getListadoAportacionesExcel(page: number, nombre: string, apellidos: string, numero: string, dni: string, fnacDesde: string, fnacHasta: string, apoDesde: string, apoHasta: string, situacionAso: number, tipoAso: number, tipoApo: number, order: string, direction: string, items: number): Observable<any> {
    const url = baseUrl + 'gestion/aportaciones/all/Excel';
    const body = { page: page, filters: { nombre: nombre, apellidos: apellidos, numero: numero, dni: dni, fnacDesde: fnacDesde, fnacHasta: fnacHasta, apoDesde: apoDesde, apoHasta: apoHasta, situacion: situacionAso, tipo: tipoAso, tipoAportacion: tipoApo }, order: order, direction: direction, items: items };

    // Realizar la petición HTTP GET con los headers incluidos
    return this.http.post<any>(url, body);
  }
  getTipoAportaciones(): Observable<any> {
    const user = JSON.parse(localStorage.getItem('currentUser') || '{}')
    const url = baseUrl + 'gestion/tipoaportaciones';

    return this.http.get<any>(url);
  }

  getTipoAportacionById(id: number): Observable<any> {
    const user = JSON.parse(localStorage.getItem('currentUser') || '{}');
    const url = baseUrl + 'gestion/tipoaportacion/' + id;

    return this.http.post<any>(url, { id: id });
  }
  saveTipoAportacion(tipoAportacion: any): Observable<any> {
    const url = baseUrl + 'gestion/tipoaportacion/alta';
    return this.http.post<any>(url, tipoAportacion);
  }
  deleteTipoAportacion(id: number): Observable<any> {
    const url = baseUrl + 'gestion/tipoaportacion/delete/' + id;
    return this.http.post<any>(url, { id: id });
  }
  updateTipoAportacion(tipoAportacion: any): Observable<any> {
    const url = baseUrl + 'gestion/tipoaportacion/save';
    if (!tipoAportacion.id) {
      throw new Error('Falta el ID del tipo de aportación');
    }
    return this.http.post<any>(url, tipoAportacion);
  }

  getTipoPrestaciones(): Observable<any> {
    const user = JSON.parse(localStorage.getItem('currentUser') || '{}')
    const url = baseUrl + 'gestion/tipoprestaciones';

    return this.http.get<any>(url);
  }

  getTipoPrestacionesById(id: string): Observable<any> {
    const url = baseUrl + 'gestion/tipoprestacion/' + id;

    return this.http.post<any>(url, null);
  }

  updateTipoPrestacion(id: number, data: any): Observable<any> {
    const url = baseUrl + 'gestion/tipoprestacion/save';

    return this.http.post<any>(url, data);
  }

  createTipoPrestacion(data: any): Observable<any> {
    const url = baseUrl + 'gestion/tipoprestacion/alta';

    return this.http.post<any>(url, data);
  }

  deleteTipoPrestacion(id: number): Observable<any> {
    const url = baseUrl + 'gestion/tipoprestacion/delete/' + id;

    return this.http.post<any>(url, null);
  }

  getTipoBajas(): Observable<any> {
    const user = JSON.parse(localStorage.getItem('currentUser') || '{}')
    const url = baseUrl + 'gestion/bajatipos';

    return this.http.get<any>(url);
  }

  getTipoBajasById(id: string): Observable<any> {
    const url = baseUrl + 'gestion/bajatipo/' + id;

    return this.http.post<any>(url, null);
  }

  updateTipoBajas(id: number, data: any): Observable<any> {
    const url = baseUrl + 'gestion/bajatipo/save';

    return this.http.post<any>(url, data);
  }

  createTipoBajas(data: any): Observable<any> {
    const url = baseUrl + 'gestion/bajatipo/alta';

    return this.http.post<any>(url, data);
  }

  deleteTipoBajas(id: number): Observable<any> {
    const url = baseUrl + 'gestion/bajatipo/delete/' + id;

    return this.http.post<any>(url, { id: id });
  }

  getParentesco(): Observable<any> {
    const user = JSON.parse(localStorage.getItem('currentUser') || '{}')

    const url = baseUrl + 'gestion/parentescos';

    return this.http.get<any>(url);
  }

  getParentescoById(id: number): Observable<any> {
    const url = baseUrl + 'gestion/parentesco/' + id;

    return this.http.post<any>(url, null);
  }

  createParentesco(data: any): Observable<any> {
    const url = baseUrl + 'gestion/parentesco/alta';

    return this.http.post<any>(url, data);
  }

  updateParentesco(id: number, data: any): Observable<any> {
    const url = baseUrl + 'gestion/parentesco/save';

    return this.http.post<any>(url, data);
  }

  deleteParentesco(id: number): Observable<any> {
    const url = baseUrl + 'gestion/parentesco/delete/' + id;

    return this.http.post<any>(url, null);
  }

  getSituacionAsociado(): Observable<any> {
    const user = JSON.parse(localStorage.getItem('currentUser') || '{}')

    const url = baseUrl + 'gestion/situaciones';

    return this.http.get<any>(url);
  }

  getSituacionAsociadoById(id: number): Observable<any> {
    const url = baseUrl + 'gestion/situacion/' + id;

    return this.http.post<any>(url, null);
  }

  createSituacionAsociado(data: any): Observable<any> {
    const url = baseUrl + 'gestion/situacion/alta';

    return this.http.post<any>(url, data);
  }

  updateSituacionAsociado(id: number, data: any): Observable<any> {
    const url = baseUrl + 'gestion/situacion/save';

    return this.http.post<any>(url, data);
  }

  deleteSituacionAsociado(id: number): Observable<any> {
    const url = baseUrl + 'gestion/situacion/delete/' + id;

    return this.http.post<any>(url, null);
  }

  getTipoAsociados(): Observable<any> {
    const user = JSON.parse(localStorage.getItem('currentUser') || '{}')
    const url = baseUrl + 'gestion/tipoasociados';

    return this.http.get<any>(url);
  }

  getTipoAsociadosById(id: string): Observable<any> {
    const url = baseUrl + 'gestion/tipoasociado/' + id;

    return this.http.post<any>(url, null);
  }

  updateTipoAsociados(id: number, data: any): Observable<any> {
    const url = baseUrl + 'gestion/tipoasociado/save';

    return this.http.post<any>(url, data);
  }

  createTipoAsociados(data: any): Observable<any> {
    const url = baseUrl + 'gestion/tipoasociado/alta';

    return this.http.post<any>(url, data);
  }

  deleteTipoAsociados(id: number): Observable<any> {
    const url = baseUrl + 'gestion/tipoasociado/delete/' + id;

    return this.http.post<any>(url, { id: id });
  }

  updateBasePrestacion(id: number, data: any): Observable<any> {
    const url = baseUrl + 'gestion/asociado/editbasepresta';

    return this.http.post<any>(url, data);
  }

  updateBajaAsociado(id: number, data: any): Observable<any> {
    const url = baseUrl + 'gestion/asociado/editbaja';

    return this.http.post<any>(url, data);
  }


  getEdadesJubilacion(): Observable<any> {
    const user = JSON.parse(localStorage.getItem('currentUser') || '{}')
    const url = baseUrl + 'gestion/edadesjubilacion';

    return this.http.get<any>(url);
  }

  getEdadesJubilacionById(id: number): Observable<any> {
    const url = baseUrl + 'gestion/edadesjubilacion/' + id;

    return this.http.post<any>(url, null);
  }

  updateEdadesJubilacion(id: number, data: any): Observable<any> {
    const url = baseUrl + 'gestion/edadesjubilacion/save';

    return this.http.post<any>(url, data);
  }

  createEdadesJubilacion(data: any): Observable<any> {
    const url = baseUrl + 'gestion/edadesjubilacion/alta';

    return this.http.post<any>(url, data);
  }

  deleteEdadesJubilacion(id: number): Observable<any> {
    const url = baseUrl + 'gestion/edadesjubilacion/delete/' + id;

    return this.http.post<any>(url, { id: id });
  }

  getAportacionesByAsociado(data: any): Observable<any> {
    const url = baseUrl + 'gestion/aportaciones/byAsociado';

    return this.http.post<any>(url, data);
  }

  getAportacionesByTipo(data: any): Observable<any> {
    const url = baseUrl + 'gestion/aportaciones/byTipo';

    return this.http.post<any>(url, data);
  }

  getPrestacionesByAsociado(data: any): Observable<any> {
    const url = baseUrl + 'gestion/prestaciones/byAsociado';

    return this.http.post<any>(url, data);
  }

  getPrestacionesByTipo(data: any): Observable<any> {
    const url = baseUrl + 'gestion/prestaciones/byTipo';

    return this.http.post<any>(url, data);
  }

  getFallecimientos(): Observable<any> {
    const url = baseUrl + 'gestion/fallecimientos';

    return this.http.get<any>(url);
  }

  deleteFallecimiento(id: number): Observable<any> {
    const url = baseUrl + 'gestion/fallecimientos/delete/' + id;

    return this.http.post<any>(url, { id: id });
  }

  getDetallesFallecimiento(id: number): Observable<any> {
    const url = baseUrl + 'gestion/fallecimientos/' + id;

    return this.http.post<any>(url, null);
  }

  getDetallesFallecimientoByAsoId(id: number): Observable<any> {
    const url = baseUrl + 'gestion/fallecimientos/fallecimientosByAsoId/' + id;

    return this.http.post<any>(url, null);
  }

  updateFallecimiento(data: any): Observable<any> {
    const url = baseUrl + 'gestion/fallecimientos/save';

    return this.http.post<any>(url, data);
  }

  createFallecimiento(data: any): Observable<any> {
    const url = baseUrl + 'gestion/fallecimientos/alta';

    return this.http.post<any>(url, data);
  }

  getDetallesFallecimientoBeneficiarios(id: number): Observable<any> {
    const url = baseUrl + 'gestion/fallecimientos/beneficiario/' + id;

    return this.http.post<any>(url, null);
  }


  getFallecimientoBeneficiariosByFallecido(id: number): Observable<any> {
    const url = baseUrl + 'gestion/fallecimientos/beneficiariosByFallecido/' + id;

    return this.http.get<any>(url);
  }


  updateFallecimientoBeneficiarios(data: any): Observable<any> {
    const url = baseUrl + 'gestion/fallecimientos/beneficiario/save';

    return this.http.post<any>(url, data);
  }

  createFallecimientoBeneficiarios(data: any): Observable<any> {
    const url = baseUrl + 'gestion/fallecimientos/beneficiario/alta';

    return this.http.post<any>(url, data);
  }

  deleteFallecimientoBeneficiarios(id: number): Observable<any> {
    const url = baseUrl + 'gestion/fallecimientos/beneficiario/delete/' + id;

    return this.http.post<any>(url, { id: id });
  }

  getTraspasos(): Observable<any> {
    const url = baseUrl + 'gestion/traspasos';

    return this.http.get<any>(url);
  }

  getTraspasoById(id: number): Observable<any> {
    const url = baseUrl + 'gestion/traspasos/' + id;

    return this.http.post<any>(url, null);
  }

  getTraspasoByAsoId(id: number): Observable<any> {
    const url = baseUrl + 'gestion/traspasos/traspasosByAso/' + id;

    return this.http.post<any>(url, null);
  }

  newTraspaso(data: any): Observable<any> {
    const url = baseUrl + 'gestion/traspasos/alta';

    return this.http.post<any>(url, data);
  }

  deleteTraspaso(id: number): Observable<any> {
    const url = baseUrl + 'gestion/traspasos/delete/' + id;

    return this.http.post<any>(url, { id: id });
  }

  saveTraspaso(data: any): Observable<any> {
    const url = baseUrl + 'gestion/traspasos/save';

    return this.http.post<any>(url, data);
  }

  getRescates(): Observable<any> {
    const url = baseUrl + 'gestion/rescates';

    return this.http.get<any>(url);
  }

  deleteRescate(id: number): Observable<any> {
    const url = baseUrl + 'gestion/rescates/delete/' + id;

    return this.http.post<any>(url, { id: id });
  }

  getDetallesRescate(id: number): Observable<any> {
    const url = baseUrl + 'gestion/rescates/' + id;

    return this.http.post<any>(url, null);
  }

  getDetallesRescateByAso(id: number): Observable<any> {
    const url = baseUrl + 'gestion/rescate/info/' + id;

    return this.http.post<any>(url, null);
  }

  updateRescate(data: any): Observable<any> {
    const url = baseUrl + 'gestion/rescates/save';

    return this.http.post<any>(url, data);
  }

  createRescate(data: any): Observable<any> {
    const url = baseUrl + 'gestion/rescates/alta';

    return this.http.post<any>(url, data);
  }

  getBajasIt(): Observable<any> {
    const url = baseUrl + 'gestion/bajasit';

    return this.http.get<any>(url);
  }

  getBajaItByAsoId(id: number): Observable<any> {
    const url = baseUrl + 'gestion/bajasit/bajasitByAsoId/' + id;

    return this.http.post<any>(url, null);
  }

  getBajaItById(id: number): Observable<any> {
    const url = baseUrl + 'gestion/bajasit/' + id;

    return this.http.post<any>(url, null);
  }

  newBajaIt(data: any): Observable<any> {
    const url = baseUrl + 'gestion/bajasit/alta';

    return this.http.post<any>(url, data);
  }
  deleteBajaIt(id: number): Observable<any> {
    const url = baseUrl + 'gestion/bajasit/delete/' + id;

    return this.http.post<any>(url, { id: id });
  }
  saveBajaIt(data: any): Observable<any> {
    const url = baseUrl + 'gestion/bajasit/save';

    return this.http.post<any>(url, data);
  }

  getParametro(id: number): Observable<any> {
    const url = baseUrl + 'gestion/parametro/' + id;

    return this.http.post<any>(url, null);

  }

  deletePendingMails(): Observable<any> {
    const url = baseUrl + 'gestion/emails/delete';

    return this.http.post<any>(url, null);

  }
  activatePendingMails(): Observable<any> {
    const url = baseUrl + 'gestion/parametro/email/act';

    return this.http.post<any>(url, null);
  }
  desactivatePendingMails(): Observable<any> {
    const url = baseUrl + 'gestion/parametro/email/desact';

    return this.http.post<any>(url, null);
  }

  getCuotasEntradas(): Observable<any> {
    const url = baseUrl + 'gestion/asociados/entrada';

    return this.http.get<any>(url);
  }

  getDetallesCuotasEntradas(id: number): Observable<any> {
    const url = baseUrl + 'gestion/asociados/entrada/aportacion/' + id;

    return this.http.post<any>(url, null);
  }

  newCuotasEntradas(data: any): Observable<any> {
    const url = baseUrl + 'gestion/asociados/entrada/alta';

    return this.http.post<any>(url, data);
  }

  updateCuotasEntradas(data: any): Observable<any> {
    const url = baseUrl + 'gestion/asociados/entrada/save';

    return this.http.post<any>(url, data);
  }

  deleteCuotasEntradas(id: number): Observable<any> {
    const url = baseUrl + 'gestion/asociados/entrada/delete/' + id;

    return this.http.post<any>(url, null);

  }

  getAlertas(): Observable<any> {
    const url = baseUrl + 'alertas';

    return this.http.get<any>(url);
  }

  getAlertasOrdenadas(): Observable<any> {
    const url = baseUrl + 'alertas/ordenadas';

    return this.http.get<any>(url);
  }

  getAlertasActivas(): Observable<any> {
    const url = baseUrl + 'alertas/activas';

    return this.http.get<any>(url);
  }

  getDetallesAlertas(id: number): Observable<any> {
    const url = baseUrl + 'alertas/detalle/' + id;

    return this.http.post<any>(url, null);
  }

  saveAlerta(data: any): Observable<any> {
    const url = baseUrl + 'alertas/save';

    return this.http.post<any>(url, data);
  }

  deleteAlerta(id: number): Observable<any> {
    const url = baseUrl + 'alertas/delete/' + id;

    return this.http.post<any>(url, null);

  }
  getListaDerechosFecha(): Observable<any> {
    const url = baseUrl + 'gestion/subirarchivos/derechos/getLista';

    return this.http.get<any>(url);
  }

  delDerechosFecha(fecha: String): Observable<any> {
    const url = baseUrl + 'gestion/subirarchivos/derechos/deleteFecha/' + fecha;

    return this.http.post<any>(url, null);
  }

  newDerechosEconomicos(data: any): Observable<any> {

    const url = baseUrl + 'gestion/subirarchivos/derechos/alta';

    return this.http.post<any>(url, data);
  }
  getListaCuotasRecurrentes(): Observable<any> {
    const url = baseUrl + 'gestion/subirarchivos/cuotaRecurrente/getLista';

    return this.http.get<any>(url);
  }

  newCuotasRecurrentes(fecha: String): Observable<any> {
    const url = baseUrl + 'gestion/subirarchivos/cuotaRecurrente/alta/' + fecha;

    return this.http.post<any>(url, null);
  }

  getFechasSinTransacciones(): Observable<any> {
    const url = baseUrl + `gestion/subirarchivos/cuotaRecurrente/getSinTransacciones`;

    return this.http.get<any>(url);
  }
  delCuotasRecurrentesFecha(fecha: String): Observable<any> {
    const url = baseUrl + 'gestion/subirarchivos/cuotaRecurrente/deleteFecha/' + fecha;

    return this.http.post<any>(url, null);
  }

  getProductos(id: string): Observable<any> {
    const url = baseUrl + 'gestion/productos/getListaAsociado/' + id;

    return this.http.get<any>(url);
  }

  newProducto(data: any): Observable<any> {
    const url = baseUrl + 'gestion/productos/alta';

    return this.http.post<any>(url, data);
  }

  getDetallesProductos(id: number): Observable<any> {
    const url = baseUrl + 'gestion/productos/detalle/' + id;

    return this.http.get<any>(url);
  }

  removeProducto(id: number): Observable<any> {
    const url = baseUrl + 'gestion/productos/remove/' + id;

    return this.http.post<any>(url, id);
  }

  getListadoTipoAportaciones(): Observable<any> {
    const url = baseUrl + 'gestion/aportaciones/getAll';

    return this.http.get<any>(url);
  }

  getListadoTipoPrestaciones(): Observable<any> {
    const url = baseUrl + 'gestion/prestaciones/getAll';

    return this.http.get<any>(url);
  }
  getListaAsociadosAportaciones(): Observable<any> {
    const url = baseUrl + 'gestion/subirarchivos/cuotaManual/getListaAso';

    return this.http.get<any>(url);
  }
  getAportacionId(id: number): Observable<any> {
    const url = baseUrl + 'gestion/aportacion/' + id

    return this.http.post<any>(url, null);
  }
  getApoTipoPorNombre(nombre: String): Observable<any> {
    const url = baseUrl + 'gestion/subirarchivos/cuotaManual/tipoNombre/' + nombre;

    return this.http.post<any>(url, null);
  }
  saveAportaciones(data: any): Observable<any> {
    const url = baseUrl + 'gestion/subirarchivos/cuotaManual/save';

    return this.http.post<any>(url, data);
  }
  saveDevoluciones(data: any): Observable<any> {
    const url = baseUrl + 'gestion/subirarchivos/cuotaManual/devolucion';

    return this.http.post<any>(url, data);
  }
  getEmpresas(): Observable<any> {
    const url = baseUrl + 'gestion/asociados/empresas';

    return this.http.get<any>(url);
  }
  saveAsociadoEditarInfo(id: number, data: any): Observable<any> {
    const url = baseUrl + 'gestion/asociado/info/' + id;

    return this.http.put<any>(url, data);
  }
  saveAsociadoEditarContacto(id: number, data: any): Observable<any> {
    const url = baseUrl + 'gestion/asociado/contacto/' + id;

    return this.http.put<any>(url, data);
  }
  saveAsociadoEditarInfoFinanciera(id: number, data: any): Observable<any> {
    const url = baseUrl + 'gestion/asociado/infofinanciera/' + id;

    return this.http.put<any>(url, data);
  }

  newBeneficiario(data: any): Observable<any> {
    const url = baseUrl + 'gestion/beneficiario/alta';

    return this.http.post<any>(url, data);
  }

  removeBeneficiario(id: number): Observable<any> {
    const url = baseUrl + 'gestion/beneficiario/delete/' + id;

    return this.http.post<any>(url, id);
  }

  getListApoSinTransaccion(): Observable<any> {
    const url = baseUrl + 'gestion/subirarchivos/aportaciones/getListCobros';

    return this.http.get<any>(url)
  }
  deleteAportacion(id: number): Observable<any> {
    const url = baseUrl + 'gestion/aportaciones/delete/' + id;

    return this.http.post<any>(url, id);
  }
  exportarAportacionesSepaXML(data: any): Observable<any> {
    const url = baseUrl + 'gestion/subirarchivos/cobros/sepaXML'

    return this.http.post<any>(url, data)
  }
  getXML(filename: string): Observable<any> {
    const url = baseUrl + 'gestion/files/sepa/' + filename

    return this.http.get<any>(url)
  }
  getAportacionesRemesas(): Observable<any> {
    const url = baseUrl + 'gestion/apo_remesas'

    return this.http.get<any>(url)
  }
  deleteAportacionesRemesas(id: number): Observable<any> {
    const url = baseUrl + 'gestion/apo_remesas/delete/' + id

    return this.http.post<any>(url, null)
  }

  getApoSEPAXML(filename: string): Observable<any> {
    const url = baseUrl + 'gestion/subirarchivos/cobros/getXML/' + filename

    return this.http.get<any>(url)
  }
  getListInfoCuotas(fecha: String): Observable<any> {
    const url = baseUrl + 'gestion/subirarchivos/cuotaRecurrente/getListInfoCuotas/' + fecha

    return this.http.get<any>(url)
  }
  getListaInfoDerechos(fecha: string): Observable<any> {
    const url = baseUrl + 'gestion/subirarchivos/derechos/getListaDatos/' + fecha

    return this.http.get<any>(url)
  }
  getListaDerechosExtra(): Observable<any> {
    const url = baseUrl + 'gestion/subirarchivos/derechosExtra/all'

    return this.http.get<any>(url)
  }


  getEpsvXML(data: any): Observable<Blob> {
    const url = baseUrl + 'gestion/epsv/generarXML';

    return this.http.post(url, data, { responseType: 'blob' })
  }

  newModelo190(data: any): Observable<any> {

    const url = baseUrl + 'gestion/modelo190/generarConExcel';

    return this.http.post<any>(url, data);
  }

  getListaPrestacionesRecurrentes(): Observable<any> {
    const url = baseUrl + 'gestion/prestaciones/prestacionRecurrente/getLista';

    return this.http.get<any>(url);
  }
  getListInfoPrestacionesRecurrente(fecha: String): Observable<any> {
    const url = baseUrl + 'gestion/prestaciones/prestacionRecurrente/getListInfoPrestaciones/' + fecha

    return this.http.get<any>(url)
  }

  newPrestacionesRecurrentes(fecha: String): Observable<any> {
    const url = baseUrl + 'gestion/prestaciones/prestacionRecurrente/alta/' + fecha;

    return this.http.post<any>(url, null);
  }

  delPrestacionesRecurrentesFecha(fecha: String): Observable<any> {
    const url = baseUrl + 'gestion/prestaciones/prestacionRecurrente/deleteFecha/' + fecha;

    return this.http.post<any>(url, null);
  }

  getExcelPdfPrestacionesRec(fecha: any): Observable<any> {
    const url = baseUrl + 'gestion/prestaciones/prestacionRecurrente/ExcelPdf/' + fecha;

    return this.http.get<any>(url)
  }

  getPrestacionId(id: number): Observable<any> {
    const url = baseUrl + 'gestion/prestacion/' + id

    return this.http.post<any>(url, null);
  }

  savePrestaciones(data: any): Observable<any> {
    const url = baseUrl + 'gestion/prestaciones/prestacionManual/save';

    return this.http.post<any>(url, data);
  }
  deletePrestacion(id: number): Observable<any> {
    const url = baseUrl + 'gestion/prestaciones/prestacionManual/delete/' + id;

    return this.http.post<any>(url, id);
  }

  getOriginalPrestacion(id: number): Observable<any> {
    const url = baseUrl + 'gestion/prestacion/prestacionManual/original/' + id

    return this.http.post<any>(url, null);

  }

  getOriginalAportacion(id: number): Observable<any> {
    const url = baseUrl + 'gestion/aportacion/aportacionManual/original/' + id

    return this.http.post<any>(url, null);

  }
  saveDevolucionesPrestaciones(data: any): Observable<any> {
    const url = baseUrl + 'gestion/prestaciones/prestacionManual/devolucion';

    return this.http.post<any>(url, data);
  }

  getListPreSinTransaccion(): Observable<any> {
    const url = baseUrl + 'gestion/prestaciones/getListPagos';

    return this.http.get<any>(url)
  }

  exportarPrestacionesSepaXML(data: any): Observable<any> {
    const url = baseUrl + 'gestion/prestaciones/pagoSepaXML'

    return this.http.post<any>(url, data)
  }

  getPrestacionesRemesas(): Observable<any> {
    const url = baseUrl + 'gestion/prestaciones/pre_remesas'

    return this.http.get<any>(url)
  }

  getPreSEPAXML(filename: string): Observable<any> {
    const url = baseUrl + 'gestion/prestaciones/getXML/' + filename

    return this.http.get<any>(url)
  }

  deletePrestacionesRemesas(id: number): Observable<any> {
    const url = baseUrl + 'gestion/prestaciones/pre_remesas/delete/' + id

    return this.http.post<any>(url, null)
  }
  getExcelCuotas(data: any): Observable<any> {
    const url = baseUrl + 'gestion/subirarchivos/cuotaRecurrente/Excel'

    return this.http.post<any>(url, data)
  }
  getCuotasRecPDF(data: any): Observable<any> {
    const url = baseUrl + 'gestion/subirarchivos/cuotaRecurrente/PDF'

    return this.http.post<any>(url, data)
  }
  getListaAporSocioProtector(): Observable<any> {
    const url = baseUrl + 'gestion/subirarchivos/aportaciones/getListApoSocioProt'

    return this.http.get<any>(url)
  }
  delApoFecha(fecha: String): Observable<any> {
    const url = baseUrl + 'gestion/subirarchivos/aportacion/deleteFecha/' + fecha;

    return this.http.post<any>(url, null);
  }
  newAportacionesSocioProtector(data: any): Observable<any> {

    const url = baseUrl + 'gestion/subirarchivos/aportacion/alta';

    return this.http.post<any>(url, data);
  }


  getListaPrestacionesRentaIT(): Observable<any> {
    const url = baseUrl + 'gestion/prestaciones/prestacionRentaIT/getLista';

    return this.http.get<any>(url);
  }
  getListInfoPrestacionesRentaIT(fecha: String): Observable<any> {
    const url = baseUrl + 'gestion/prestaciones/prestacionRentaIT/getListInfoPrestaciones/' + fecha

    return this.http.get<any>(url)
  }

  delPrestacionesRentaITFecha(fecha: String): Observable<any> {
    const url = baseUrl + 'gestion/prestaciones/prestacionRentaIT/deleteFecha/' + fecha;

    return this.http.post<any>(url, null);
  }

  getListaBajasITActivas(): Observable<any> {
    const url = baseUrl + 'gestion/bajasitActivas';

    return this.http.get<any>(url);
  }

  getListaBajasITRentasIT(): Observable<any> {
    const url = baseUrl + 'gestion/bajasitActivasRentasIT';

    return this.http.get<any>(url);
  }


  newPrestacionRentaIT(fecha: String, id: number): Observable<any> {
    const url = baseUrl + 'gestion/prestaciones/prestacionRentaIT/altaRentaIT/' + fecha;

    return this.http.post<any>(url, id);
  }

  getExcelPdfPrestacionesRentaIT(fecha: any): Observable<any> {
    const url = baseUrl + 'gestion/prestaciones/prestacionRentaIT/ExcelPdf/' + fecha;

    return this.http.get<any>(url)
  }

  getModelo345(data: any): Observable<any> {
    const url = baseUrl + 'gestion/modelo345/generar';

    return this.http.post<any>(url, data)
  }

  getEpsv(): Observable<any> {
    const url = baseUrl + 'gestion/epsv';

    return this.http.get<any>(url);
  }

  getConsultaFallecidosXML(): Observable<any> {
    const url = baseUrl + 'gestion/consultaFallecidos';

    return this.http.get<any>(url)
  }
  getEpsvActivos(): Observable<any> {
    const url = baseUrl + 'gestion/epsv/activos';

    return this.http.get<any>(url);
  }

  deleteEpsv(id: number): Observable<any> {
    const url = baseUrl + 'gestion/epsv/delete/' + id;

    return this.http.post<any>(url, null);
  }
  getEpsvById(id: number): Observable<any> {
    const url = baseUrl + 'gestion/epsv/' + id;

    return this.http.post<any>(url, null);
  }
  createEpsv(data: any): Observable<any> {
    const url = baseUrl + 'gestion/epsv/alta';

    return this.http.post<any>(url, data);
  }
  updateEpsv(id: number, data: any): Observable<any> {
    const url = baseUrl + 'gestion/epsv/save';

    return this.http.post<any>(url, data);
  }
  getYearTraspasos(): Observable<any> {
    const url = baseUrl + 'gestion/traspasos/year';

    return this.http.get<any>(url)
  }
  newModelo134(year: number, asoId: number): Observable<any> {
    const url = baseUrl + 'gestion/epsv/modelo134';
    const body = { year: year.toString(), asoId: asoId.toString()};

    return this.http.post(url, body)
  }
  getAsoTotales(): Observable<any> {
    const url = baseUrl + 'gestion/asociados/totales';

    return this.http.get<any>(url)
  }
  saveAsociado(data: any): Observable<any> {
    const url = baseUrl + 'gestion/asociado/nuevo';

    return this.http.post<any>(url, data);
  }
  getAsoBorrarTotales(data: any): Observable<any> {
    const url = baseUrl + 'gestion/asociado/datosBorrar';

    return this.http.post<any>(url, data)
  }
  deleteAsociado(id: number): Observable<any> {
    const url = baseUrl + 'gestion/asociado/delete/' + id;

    return this.http.post<any>(url, null);
  }
  getYearAportaciones(): Observable<any> {
    const url = baseUrl + 'gestion/aportaciones/year';

    return this.http.get<any>(url)
  }

  getFormasCobro(): Observable<any> {
    const user = JSON.parse(localStorage.getItem('currentUser') || '{}')
    const url = baseUrl + 'gestion/formasCobro';

    return this.http.get<any>(url);
  }
  getAllAsociadosFeDeVida(year: number): Observable<any> {
    const url = baseUrl + 'gestion/asociados/minFeDeVida/' + year;

    return this.http.get<any>(url);
  }
  getVidaForma(): Observable<any> {
    const url = baseUrl + 'gestion/feDeVidaForma/all';

    return this.http.get<any>(url)
  }

  getYearVida(): Observable<any> {
    const url = baseUrl + 'gestion/feDeVida/year';

    return this.http.get<any>(url)
  }

  getDetallesFeDeVida(id: number): Observable<any> {
    const url = baseUrl + 'gestion/feDeVida/getFe/' + id;

    return this.http.get<any>(url);
  }

  deleteFeDeVida(id: number): Observable<any> {
    const url = baseUrl + 'gestion/feDeVida/delete/' + id;

    return this.http.post<any>(url, { id: id });
  }

  updateFeDeVida(data: any): Observable<any> {
    const url = baseUrl + 'gestion/feDeVida/save';

    return this.http.post<any>(url, data);
  }

  createFeDeVida(data: any): Observable<any> {
    const url = baseUrl + 'gestion/feDeVida/alta';

    return this.http.post<any>(url, data);
  }

  getAsociadosGenerar(data: any): Observable<any> {
    const url = baseUrl + 'gestion/asociadosgenerar';

    return this.http.post<any>(url, data);
  }

  updateProductos(): Observable<any> {
    const url = baseUrl + 'gestion/productosversiones/actualizar';

    return this.http.get<any>(url);
  }

  getProductosVersiones(): Observable<any> {
    const url = baseUrl + 'gestion/productosversiones/all';

    return this.http.get<any>(url)
  }

  deleteProductoVersion(id: number): Observable<any> {
    const url = baseUrl + 'gestion/productosversiones/delete/' + id;

    return this.http.post<any>(url, { id: id });
  }

  getUltimaPrestacion(): Observable<any> {
    const url = baseUrl + 'gestion/prestaciones/ultimopago';

    return this.http.get<any>(url)
  }

  getUltimaAportacion(): Observable<any> {
    const url = baseUrl + 'gestion/aportaciones/ultimopago';

    return this.http.get<any>(url)
  }

  getProductosVersionesImporteUltimoId(): Observable<any> {
    const url = baseUrl + 'gestion/productosversiones/importes/ultimos';

    return this.http.get<any>(url)
  }

  saveProductosVersionesImportes(data: any): Observable<any> {
    const url = baseUrl + 'gestion/productosversiones/importes/alta';

    return this.http.post<any>(url, data)
  }

  getProductosImportesEsteYear(year: any): Observable<any> {
    const url = baseUrl + 'gestion/productosversiones/importes/year/' + year;

    return this.http.get<any>(url)
  }

  getUltimoProductosVersionesImporte(): Observable<any> {
    const url = baseUrl + 'gestion/productosversiones/ultimoimporte';

    return this.http.get<any>(url)
  }

  getRemesasImporte(): Observable<any> {
    const url = baseUrl + 'gestion/productosversiones/importes/remesas';

    return this.http.get<any>(url)
  }

  deleteRemesaImporte(year: number): Observable<any> {
    const url = baseUrl + 'gestion/productosversiones/deleteremesa/' + year;

    return this.http.post<any>(url, { year: year });
  }

  getExcelActualizaciones(id: number): Observable<any> {
    const url = baseUrl + 'gestion/productosversiones/excelactualizados/' + id;

    return this.http.get<any>(url)
  }

  getVersionesLastId(): Observable<any> {
    const url = baseUrl + 'gestion/productosversiones/lastId';

    return this.http.get<any>(url)
  }

  getAntiguedadPDF(id: number): Observable<any> {
    const url = baseUrl + 'gestion/antiguedadPDF/' + id;

    return this.http.get<any>(url)
  }

  getAtencionAsociados(): Observable<any> {
    const url = baseUrl + 'gestion/atencionasociados';

    return this.http.get<any>(url);
  }

  getAtencionAsociadoId(id: number): Observable<any> {
    const url = baseUrl + 'gestion/atencionasociados/' + id

    return this.http.post<any>(url, null);
  }

  getCanalesAtencion(): Observable<any> {
    const url = baseUrl + 'gestion/canalesatencion';

    return this.http.get<any>(url);
  }

  getMotivosConsulta(): Observable<any> {
    const url = baseUrl + 'gestion/motivosconsulta';

    return this.http.get<any>(url);
  }

  getMotivosConsultaActivos(): Observable<any> {
    const url = baseUrl + 'gestion/motivosconsultaactivos';

    return this.http.get<any>(url);
  }

  saveConsultaAtencion(data: any): Observable<any> {
    const url = baseUrl + 'gestion/atencionasociados/save';

    return this.http.post<any>(url, data);
  }

  getMotivoConsultaId(id: number): Observable<any> {
    const url = baseUrl + 'gestion/motivosconsulta/' + id

    return this.http.post<any>(url, null);
  }

  saveMotivoConsulta(data: any): Observable<any> {
    const url = baseUrl + 'gestion/motivosconsulta/save';

    return this.http.post<any>(url, data);
  }

  deleteMotivoConsulta(id: number): Observable<any> {
    const url = baseUrl + 'gestion/motivosconsulta/delete/' + id;

    return this.http.post<any>(url, { id: id });
  }

  deleteAtencionAsociado(id: number): Observable<any> {
    const url = baseUrl + 'gestion/atencionasociados/delete/' + id;

    return this.http.post<any>(url, { id: id });
  }

  excelPrestacionAsociado(data: any): Observable<any> {
    const url = baseUrl + 'gestion/prestaciones/byAsociado/excel';

    return this.http.post<any>(url, data);
  }

  deleteAtencionAsociadoAndAteId(id: number): Observable<any> {
    const url = baseUrl + 'gestion/atencionasociados/deleteFe/' + id;

    return this.http.post<any>(url, { id: id });
  }

  getFedeByAtencion(id: number): Observable<any> {
    const url = baseUrl + 'gestion/feDeVida/ateid/' + id

    return this.http.get<any>(url);
  }

  getAsociadoBySituacion(id: number): Observable<any> {
    const url = baseUrl + 'gestion/asociado/situacion/' + id

    return this.http.post<any>(url, null);
  }

}
